<script setup lang="ts">
const props = defineProps({
  file: null,
  peek: { type: Boolean }
})
const { file } = toRefs(props)
const { rendererState } = useRenderer({ file, onlineOnly: true })

// TODO: this will fail while offline, can we show a better error message?

const officeUrl = computed(() => {
  if (rendererState.value.loading || !rendererState.value.presignedUrl)
    return
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(rendererState.value.presignedUrl)}`.trim()
})
</script>

<template>
  <div
    class="renderer-container"
    :class="{ peek }"
    tabindex="0"
  >
    <iframe
      v-if="officeUrl"
      tabindex="-1"
      class="renderer-iframe"
      :src="officeUrl"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply flex items-center justify-center relative
  &.peek
    @apply w-[75vw] h-[75vh]

.renderer-iframe
  @apply absolute top-0 left-0 w-full h-full
</style>
